export const SET_CATEGORIES = 'categories/SET';

export const setCategories = payload => ({
  type: SET_CATEGORIES,
  payload,
});
